import axios from '../helpers/axios'
import { logError } from '../services';
import { IDelayedJob, IDelayedJobs } from '../models';

export const getDelayedJobs = async (filters?: {
  territoryId?: string | number;
  neighborhoodId?: string | number;
  startWeekToDelayFrom?;
  weeksToDelay?;
}): Promise<IDelayedJob[]> => {
  try {
    const { data } = await axios.get(`/api/jobs/delay-start`, { params: filters });
    return data;
  } catch (error) {
    logError(error, 'getDelayedJobs failed');
    return Promise.reject(error?.response?.data);
  }
};

export const updateDelayedJobs = async (post: IDelayedJobs): Promise<any[]> => {
  try {
    const { data } = await axios.post(`/api/jobs/delay-start`, post);
    return data;
  } catch (error) {
    logError(
      {
        error,
        payload: post
      },
      'updateDelayedJobs failed'
    );
    return Promise.reject(error);
  }
};
